export const beginCall = () => ({ type: 'BEGIN_AJAX_CALL' });

export const errorCall = () => ({ type: 'AJAX_CALL_ERROR' });
